import { gql, type TypedDocumentNode } from '@apollo/client';
import type { CSSProperties } from 'react';

import { RewardConfigText } from '../RewardConfigText/index.tsx';
import type { BoostedRewardConfigText_anyRewardConfigInterface } from './__generated__/index.graphql.ts';

type Props = {
  rewardConfig: BoostedRewardConfigText_anyRewardConfigInterface;
  originalRewardConfig?: BoostedRewardConfigText_anyRewardConfigInterface | null;
};

export const BoostedRewardConfigText = ({
  rewardConfig,
  originalRewardConfig,
}: Props) => (
  <>
    <span
      {...(originalRewardConfig
        ? {
            className: 'text-gradient-color',
            style: {
              '--text-gradient-color': 'var(--c-gradient-greenYellow)',
            } as CSSProperties,
          }
        : {})}
    >
      <RewardConfigText anyRewardConfig={rewardConfig} />
    </span>
    {!!originalRewardConfig && (
      <>
        &nbsp;
        <span
          style={{ textDecoration: 'line-through', color: 'var(--c-nd-400)' }}
        >
          <RewardConfigText
            anyRewardConfig={originalRewardConfig}
            disableMonetaryRewardDisclaimer
          />
        </span>
      </>
    )}
  </>
);

BoostedRewardConfigText.fragments = {
  anyRewardConfigInterface: gql`
    fragment BoostedRewardConfigText_anyRewardConfigInterface on AnyRewardConfigInterface {
      id
      ...RewardConfigText_anyRewardConfigInterface
    }
    ${RewardConfigText.fragments.anyRewardConfigInterface}
  ` as TypedDocumentNode<BoostedRewardConfigText_anyRewardConfigInterface>,
};
